export default "__VITE_ASSET__DU$lot2u__"